import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=83009ad8&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=83009ad8&prod&lang=scss&scoped=true"
import style1 from "./Customer.vue?vue&type=style&index=1&id=83009ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83009ad8",
  null
  
)

export default component.exports